import { render, staticRenderFns } from "./CRMEditBaseInfo.vue?vue&type=template&id=095f83cc&scoped=true"
import script from "./CRMEditBaseInfo.vue?vue&type=script&lang=js"
export * from "./CRMEditBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./CRMEditBaseInfo.vue?vue&type=style&index=0&id=095f83cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095f83cc",
  null
  
)

export default component.exports